import { Badge, Box, FolderIcon, TextWithTooltip } from "@hightouch/htui";
import type { ElementType } from "react";

import type { DirectoryNode } from "src/components/asset-picker/build-directory-tree";

export type FolderTile = Pick<DirectoryNode, "path" | "name"> & {
  /** Replaces the folder glyph, e.g. for a folder that stands for a file type. */
  icon?: ElementType;
  /** Files inside, shown as a badge. */
  count?: number;
};

type Props = {
  folders: FolderTile[];
  onSelect: (directory: string) => void;
};

export const FolderTileGrid = ({ folders, onSelect }: Props) => (
  <Box
    display="grid"
    gridTemplateColumns="repeat(auto-fill, minmax(220px, 1fr))"
    gap={3}
  >
    {folders.map((folder) => (
      <Box
        key={folder.path}
        as="button"
        type="button"
        display="flex"
        alignItems="center"
        gap={2}
        height={10}
        px={3}
        textAlign="left"
        minWidth={0}
        borderWidth="hairline"
        borderStyle="solid"
        borderColor="base.border"
        borderRadius="lg"
        bg="base.lightBackground"
        _hover={{ borderColor: "base.borderHover", bg: "white" }}
        _focusVisible={{ boxShadow: "outline" }}
        onClick={() => onSelect(folder.path)}
      >
        <Box
          as={folder.icon ?? FolderIcon}
          color="text.secondary"
          boxSize={5}
          flexShrink={0}
        />
        <Box flex={1} minWidth={0}>
          <TextWithTooltip fontWeight="medium" isTruncated>
            {folder.name}
          </TextWithTooltip>
        </Box>
        {folder.count !== undefined && (
          <Box flexShrink={0}>
            <Badge size="sm">{folder.count}</Badge>
          </Box>
        )}
      </Box>
    ))}
  </Box>
);
